import { Stat } from '../../api';
import MonthPieChart from './MonthPieChart';

function getDomains(data: Stat): Record<string, Array<number>> {
  return data?.frames?.positions ? data.frames.positions : {};
}

function getTitle(): string {
  return 'Frames bandwidth usage by position';
}

export default function MonthCameraFramesPositionsChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
}) {
  return <MonthPieChart getTitle={getTitle} getDomains={getDomains} {...props} />;
}
